import React from "react";

interface PostCloseTouchpointData {
  benchmark: string; meetingsCompleted30Days: string; totalMeetings: string;
  percentCompleted: string; percentVsBenchmark: string; bonusPercentEarned: string; bonusValue: string; score: string;
}
interface PostCloseTouchpointSubFormProps {
  data: PostCloseTouchpointData; isEditable: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const PostCloseTouchpointSubForm: React.FC<PostCloseTouchpointSubFormProps> = ({ data, isEditable, onInputChange }) => (
  <div className="sf-section">
    <h3 className="sf-title">30-Day Post-Close Touchpoint (10% of total achievement score)</h3>
    <p className="sf-subtitle">The goal is 100% of all meetings completed within 30 days of closing.</p>
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="sf-label">This quarter the benchmark was:</label>
        <input type="text" readOnly name="customerExperience.postCloseTouchpoint.benchmark"
          value={data.benchmark?.replace('%', '') || "100"}
          className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
      </div>
      <div className="space-y-4">
        <div>
          <label className="sf-label">Meetings Completed 30 or Fewer Days</label>
          <input type="text" name="customerExperience.postCloseTouchpoint.meetingsCompleted30Days"
            inputMode="numeric" maxLength={3} minLength={1}
            value={data.meetingsCompleted30Days || ""} placeholder="0" onFocus={e => e.target.select()}
            onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })} disabled={!isEditable}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">Total Meetings</label>
          <input type="text" name="customerExperience.postCloseTouchpoint.totalMeetings"
            inputMode="numeric" maxLength={3} minLength={1}
            value={data.totalMeetings} placeholder="0" onFocus={e => e.target.select()}
            onChange={e => onInputChange(e, { type: "number", maxLength: 3, minLength: 1 })} disabled={!isEditable}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">% Meetings Completed within 30 days</label>
          <input type="text" readOnly name="customerExperience.postCloseTouchpoint.percentCompleted"
            value={data.percentCompleted && !isNaN(parseFloat(data.percentCompleted)) ? Math.ceil(parseFloat(data.percentCompleted)).toString() : "0"}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
      </div>
    </div>
    <p className="sf-hint">70%–100% of Benchmark</p>
    <div className="sf-results grid grid-cols-4 gap-4">
      <div>
        <div className="sf-results-label">Bonus % Earned</div>
        <input type="text" readOnly name="customerExperience.postCloseTouchpoint.bonusPercentEarned"
          value={data.bonusPercentEarned && !isNaN(parseFloat(data.bonusPercentEarned)) ? Math.ceil(parseFloat(data.bonusPercentEarned)).toString() : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>  
      <div>
        <div className="sf-results-label">10%</div>
        <input type="text" readOnly name="customerExperience.postCloseTouchpoint.bonusValue"
          value={data.bonusValue ? parseFloat(data.bonusValue).toFixed(2) : "0.10"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">Score</div>
        <input type="text" readOnly name="customerExperience.postCloseTouchpoint.score"
          value={data.score && !isNaN(parseFloat(data.score)) ? Math.ceil(parseFloat(data.score)).toString() : "0"}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
    </div>
  </div>
);

export default PostCloseTouchpointSubForm;